import { getFullUrl } from 'hubspot-url-utils';
export const generatePublicProfileUrl = userId => {
  return `${getFullUrl('app')}/academy-profile/member/${userId}`;
};